import React from "react";
import Selector from "@ui/Selector";
import { useQOI } from "./useQOI";
import type { PerformanceReporting } from "../../../api/useReporting";
import { HIDE_ON_WIDGET_EXPORT } from "@ui/ExportWidgetButton";

function PerformanceIndicatorSelector({ reporting }: { reporting: PerformanceReporting }) {
  const [qoi, setQOIName] = useQOI(reporting);

  const selectorOptions = React.useMemo(
    () =>
      Object.values(reporting.qoiById).reduce<{ label: string; value: string }[]>((acc, qoi) => {
        if (!acc.find(o => o.value === qoi.name)) acc.push({ label: qoi.name, value: qoi.name });
        return acc;
      }, []),
    [reporting],
  );

  if (Object.keys(reporting.qoiById).length <= 1) return null;

  return (
    <Selector
      options={selectorOptions}
      value={qoi?.name ?? null}
      onChange={setQOIName}
      className={HIDE_ON_WIDGET_EXPORT}
    />
  );
}

export default React.memo(PerformanceIndicatorSelector);
